import { render, staticRenderFns } from "./TabForms.vue?vue&type=template&id=6cc20525&scoped=true"
import script from "./TabForms.vue?vue&type=script&lang=js"
export * from "./TabForms.vue?vue&type=script&lang=js"
import style0 from "./TabForms.vue?vue&type=style&index=0&id=6cc20525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc20525",
  null
  
)

export default component.exports